import { render } from "./ColumnProperties.vue?vue&type=template&id=56e2696e"
import script from "./ColumnProperties.vue?vue&type=script&lang=js"
export * from "./ColumnProperties.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.26.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__